import AvailableUnits from '../../../../components/available-units/available-units.desktop';

import availableUnits from './available-units';

export default availableUnits(AvailableUnits);
